import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const GranitPulti = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Granit pulti"
          subtitle="Granitni pulti za brezčasen videz"
          imageSrc="/placeholder.svg"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Granit pulti"
            subtitle="Granitni pulti za brezčasen videz"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Granitni pulti so ena izmed najbolj priljubljenih izbir za kuhinje in kopalnice.
              Njihova trdnost, odpornost proti vročini, praskam in madežem jih dela idealne za vsakodnevno uporabo.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Granit pulti 1" },
              { src: "/placeholder.svg", alt: "Granit pulti 2" },
              { src: "/placeholder.svg", alt: "Granit pulti 3" },
              { src: "/placeholder.svg", alt: "Granit pulti 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default GranitPulti;